import { Steps, FormItem, Button } from 'vnetwork-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomerIcons from '@/icons/CustomerIcons'
import PersonIcons from '@/icons/PersonIcons'
import SettingIcons from '@/icons/SettingIcons'
import { Path, useFormContext } from 'react-hook-form'
import { Contract } from '@/modules/Contract/types'
import CustomerInformation from '../DomainFormFields/CustomerInformation'
import DeclaresInformation from '../DomainFormFields/DeclaresInformation'
import AdminInformation from '../DomainFormFields/AdminInformation'

interface DomainStepsFormProps {
    rootName: string
    showConfiguration?: boolean
    showSubmitButton?: boolean
    isPending?: boolean
    onSubmit?: () => void
    isServiceSettings?: boolean
}

const DomainStepsForm: React.FC<DomainStepsFormProps> = ({
    rootName,
    // showConfiguration = false,
    showSubmitButton = false,
    isPending = false,
    onSubmit,
    // isServiceSettings = false,
}) => {
    const [currentStep, setCurrentStep] = useState(1)
    const { t } = useTranslation()
    const formControl = useFormContext<Contract>()

    // const ConfigurationInformation = () => {
    //     const domain_type = useWatch({
    //         control: formControl.control,
    //         name: `${rootName}.domain_type` as Path<Contract>,
    //         defaultValue: 'register',
    //     })
    //     return (
    //         <div className="px-4 pt-2 pb-4">
    //             <div className="grid xs:grid-cols-1 md:grid-cols-2 gap-4">
    //                 <div className="col-span-full">
    //                     <FormItem
    //                         control={formControl.control}
    //                         name={`${rootName}.domain_type` as Path<Contract>}
    //                         type="radiogroup"
    //                         label={t('domain_type')}
    //                         options={[
    //                             { value: 'register', label: 'Đăng ký mới' },
    //                             {
    //                                 value: 'transfer',
    //                                 label: 'Đổi nhà cung cấp',
    //                             },
    //                         ]}
    //                         direction="row"
    //                         size="small"
    //                     />
    //                 </div>
    //                 <FormItem
    //                     control={formControl.control}
    //                     name={`${rootName}.domain_value` as Path<Contract>}
    //                     type="textfield"
    //                     label={t('domain_value')}
    //                     placeholder={t('domain_value')}
    //                     size="small"
    //                 />
    //                 {domain_type === 'transfer' && (
    //                     <div className="col-span-full">
    //                         <FormItem
    //                             control={formControl.control}
    //                             name={
    //                                 `${rootName}.domain_eppcode` as Path<Contract>
    //                             }
    //                             type="textfield"
    //                             label={t('domain_eppcode')}
    //                             placeholder={t('domain_eppcode')}
    //                             size="small"
    //                         />
    //                     </div>
    //                 )}
    //                 <div className="col-span-full">
    //                     <FormItem
    //                         control={formControl.control}
    //                         name={`${rootName}.addons` as Path<Contract>}
    //                         type="checkboxgroup"
    //                         label={t('domain_addons')}
    //                         options={[
    //                             {
    //                                 value: 'domain_dns_management',
    //                                 label: 'DNS Management',
    //                             },
    //                             {
    //                                 value: 'domain_email_forwarding',
    //                                 label: 'Email Forwarding',
    //                             },
    //                             {
    //                                 value: 'domain_id_protection',
    //                                 label: 'ID Protection',
    //                             },
    //                         ]}
    //                         direction="row"
    //                         size="small"
    //                     />
    //                 </div>
    //                 <div className="col-span-full">
    //                     <FormItem
    //                         control={formControl.control}
    //                         name={`${rootName}.dns_option` as Path<Contract>}
    //                         type="radiogroup"
    //                         label={t('dns_option')}
    //                         options={[
    //                             { value: 'default', label: 'DNS mặc định' },
    //                             { value: 'custom', label: 'DNS khác' },
    //                         ]}
    //                         direction="row"
    //                         size="small"
    //                     />
    //                 </div>
    //                 <FormItem
    //                     control={formControl.control}
    //                     name={`${rootName}.sendmail` as Path<Contract>}
    //                     type="checkbox"
    //                     label={t('send-notification-email')}
    //                     size="small"
    //                 />
    //             </div>
    //         </div>
    //     )
    // }

    const SendmailField = () => {
        return (
            <div className="px-4 pt-4" data-tour="vnnic-settings">
                <div className="grid xs:grid-cols-1 md:grid-cols-2 gap-4">
                    <FormItem
                        control={formControl.control}
                        name={`${rootName}.sendmail` as Path<Contract>}
                        type="checkbox"
                        label={t('send-notification-email')}
                        size="small"
                    />
                </div>
            </div>
        )
    }

    const getSteps = () => {
        // if (showConfiguration && isServiceSettings) {
        //     // Service Settings steps with configuration
        //     return {
        //         1: <ConfigurationInformation />,
        //         2: <ServiceCustomerInformation rootName={rootName} />,
        //         3: <ServiceUIInformation rootName={rootName} />,
        //         4: <ServiceAdminInformation rootName={rootName} />,
        //     }
        // } else if (isServiceSettings) {
        //     // Service Settings steps without configuration (configuration shown separately)
        //     return {
        //         1: <ServiceCustomerInformation rootName={rootName} />,
        //         2: <ServiceUIInformation rootName={rootName} />,
        //         3: <ServiceAdminInformation rootName={rootName} />,
        //     }
        // } else if (showConfiguration) {
        //     // Contract with configuration
        //     return {
        //         1: <ConfigurationInformation />,
        //         2: <CustomerInformation rootName={rootName} />,
        //         3: <DeclaresInformation rootName={rootName} />,
        //         4: <AdminInformation rootName={rootName} />,
        //     }
        // } else {
        //     // Contract without configuration
        //     return {
        //         1: <CustomerInformation rootName={rootName} />,
        //         2: <DeclaresInformation rootName={rootName} />,
        //         3: <AdminInformation rootName={rootName} />,
        //         4: <SendmailField />,
        //     }
        // }

        return {
            1: <CustomerInformation rootName={rootName} />,
            2: <DeclaresInformation rootName={rootName} />,
            3: <AdminInformation rootName={rootName} />,
            4: <SendmailField />,
        }
    }

    const steps = getSteps()

    const getStepsConfig = () => {
        return [
            {
                label: t('customer-information'),
                description: '',
                icon: <CustomerIcons />,
            },
            {
                label: t('declares-information'),
                description: '',
                icon: <PersonIcons />,
            },
            {
                label: t('admin-information'),
                description: '',
                icon: <SettingIcons />,
            },
            {
                label: t('additional-settings'),
                description: '',
                icon: <SettingIcons />,
            },
        ]
    }

    const StepComponent = steps?.[currentStep as keyof typeof steps]

    return (
        <div
            className="bg-white rounded-[8px] mt-2 py-2"
            data-tour="vnnic-steps"
        >
            <Steps
                steps={getStepsConfig()}
                direction="vertical"
                color="primary"
                currentStep={currentStep}
                actions={[]}
                onChange={(step) => setCurrentStep(step)}
                size="small"
            >
                <div data-tour={`vnnic-step-${currentStep}`}>
                    {StepComponent}
                </div>
                {currentStep === Object.keys(getSteps()).length &&
                    showSubmitButton && (
                        <div className="px-4 pt-4">
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                loading={isPending}
                                disabled={isPending}
                                onClick={onSubmit}
                            >
                                {t('submit')}
                            </Button>
                        </div>
                    )}
            </Steps>
        </div>
    )
}

export default DomainStepsForm
